import { useEffect } from "react";
import cx from "classnames";

import Column from "../../../../Column";
import Textfield from "../../../../Profile/Textfield";
import nameFieldData from "../../../../Profile/AccountCreate/fieldData";
import addressFieldData from "../../../../Profile/Address/fieldData";
import SelectBox from "../../../../SelectBox";
import { statesv2, stateText } from "../../../../../utils/stateData";
import { fieldData as phoneFieldData } from "../../../../Profile/Phone";
import CreditCard from "./Components/CreditCard";
import CouponCode from "./Components/CouponCode";
import t from "../../../../../utils/translate";
import useAppContext from "../../../../AppContext";

import styles from "./styles.module.scss";

/**
 *
 * @param {object} props
 * @param {object} props.data
 * @param {string} props.data.firstName
 * @param {string} props.data.lastName
 * @param {string} props.data.street1
 * @param {string} props.data.street2
 * @param {string} props.data.city
 * @param {string} props.data.state
 * @param {string} props.data.postalCode
 * @param {string} props.data.phone
 * @param {boolean} props.isCardElementTouched
 * @param {boolean} props.isCheckoutBtnTouched
 * @param {function} props.onChange
 * @param {function} props.setIsCardElementValid
 * @param {function} props.setIsBillingInfoValid
 * @param {function} props.setIsCardElementTouched
 * @returns
 */
const PaymentForm = ({
  data,
  plan,
  onChange,
  setDiscount,
  isCardElementTouched,
  isCheckoutBtnTouched,
  setIsCardElementValid,
  setIsCardElementTouched
}) => {
  const { setForceValidation } = useAppContext();

  useEffect(() => {
    setForceValidation(true);
  }, []);

  return (
    <Column className={styles.col}>
      {!data.couponCode && (
        <CouponCode plan={plan} onChange={onChange} setDiscount={setDiscount} />
      )}
      <h2 className={styles.heading2}>
        {t("CLINIC_CHECKOUT_PAYMENT_METHOD_HEADER")}{" "}
      </h2>
      <CreditCard
        setIsCardElementValid={setIsCardElementValid}
        setIsCardElementTouched={setIsCardElementTouched}
        isCardElementTouched={isCardElementTouched}
        isCheckoutBtnTouched={isCheckoutBtnTouched}
      />
      <Column>
        <div />
        <h2 className={styles.heading2}>
          {t("CLINIC_CHECKOUT_BILLING_INFO_HEADER")}
        </h2>

        <div className={styles.addressRow}>
          <Textfield
            {...nameFieldData.firstName}
            placeholder={t("FIRST_NAME_LABEL")}
            styles={styles}
            value={data.firstName}
            onChange={onChange}
            data-recurly="first_name"
            wrapperClassName={styles.halfCell}
            withAutofocus={false}
            inputPreset="billing"
          />

          <Textfield
            {...nameFieldData.lastName}
            placeholder={t("LAST_NAME_LABEL")}
            styles={styles}
            value={data.lastName}
            onChange={onChange}
            data-recurly="last_name"
            wrapperClassName={styles.halfCell}
            withAutofocus={false}
            inputPreset="billing"
          />
        </div>

        <Textfield
          {...addressFieldData.addressLine1}
          name="street1"
          styles={styles}
          value={data.street1}
          onChange={onChange}
          data-recurly="address1"
          withAutofocus={false}
          inputPreset="billing"
        />

        <Textfield
          {...addressFieldData.addressLine2}
          name="street2"
          styles={styles}
          value={data.street2}
          onChange={onChange}
          data-recurly="address2"
          withAutofocus={false}
          inputPreset="billing"
        />

        <Textfield
          {...addressFieldData.city}
          styles={styles}
          value={data.city}
          onChange={onChange}
          data-recurly="city"
          withAutofocus={false}
          inputPreset="billing"
        />

        <div className={styles.addressRow}>
          <SelectBox
            options={statesv2}
            placeholder={stateText}
            selection={data.state}
            onChange={value => onChange("state", value)}
            wrapperClassName={cx(styles.stateCtn, styles.halfCell)}
            selectClassName={styles.select}
            withAutofocus={false}
          />
          <Textfield
            {...addressFieldData.zipcode}
            name="postalCode"
            styles={styles}
            value={data.postalCode}
            onChange={onChange}
            data-recurly="postal_code"
            wrapperClassName={styles.halfCell}
            withAutofocus={false}
            inputPreset="billing"
          />
        </div>
        <Textfield
          {...phoneFieldData.phoneNumber}
          name="phone"
          styles={styles}
          value={data.phone}
          onChange={onChange}
          withAutofocus={false}
          inputPreset="billing"
        />
      </Column>
      <input
        type="hidden"
        name="country"
        data-recurly="country"
        value={data.country}
      />
      <input type="hidden" data-recurly="state" value={data.state} />
      <input
        type="hidden"
        value={`${data.firstName} ${data.lastName}`}
        name="name_on_account"
        data-recurly="name_on_account"
      />
    </Column>
  );
};

export default PaymentForm;
